import Swiper from 'swiper';
import {applyCustomSwiperWidth} from '%widgets%/widget-slider';

export const initiateSliderCards = widget => {
  const swiperEl = widget.querySelector('.swiper');

  if (!swiperEl) return;

  const {swiperSpaceBetween = 16} = widget.dataset;

  const id = widget.id;
  const swiperScrollbar = widget.querySelector('.swiper-scrollbar');
  const swiperBtnNext = widget.querySelector('.swiper-btn-next');
  const swiperBtnPrev = widget.querySelector('.swiper-btn-prev');
  const dropdownWrapper = widget.closest('.dropdown');

  const swiperOptions = {
    loop: !swiperScrollbar,
    slidesPerView: 'auto',
    spaceBetween: Number(swiperSpaceBetween),
    scrollbar: {
      el: swiperScrollbar,
      hide: false,
      draggable: true,
    },
    navigation: {
      nextEl: swiperBtnNext
        ? swiperBtnNext
        : id && document.querySelector(`.swiper-btn-next[data-bs-target="#${id}"]`),
      prevEl: swiperBtnPrev
        ? swiperBtnPrev
        : id && document.querySelector(`.swiper-btn-prev[data-bs-target="#${id}"]`),
    },
    on: {
      init(swiper) {
        widget.classList.add('is-swiper-initialized');
        widget.classList.toggle('with-slidesPerView-auto', swiper.params.slidesPerView === 'auto');
        if (swiperEl.querySelector('.widget-card.bg-white')) widget.classList.add('with-pb');

        applyCustomSwiperWidth(widget, swiperEl);

        if (dropdownWrapper) {
          swiper._handlers = {
            handleDropdownShown: () => {
              swiper.update();
            },
            handleDropdownHide: e => {
              if (swiper._moved) {
                e.preventDefault();
                swiper._moved = false;
              }
            },
          };

          dropdownWrapper.addEventListener('shown.bs.dropdown', swiper._handlers.handleDropdownShown);
          dropdownWrapper.addEventListener('hide.bs.dropdown', swiper._handlers.handleDropdownHide);
        }

        swiperEl.querySelectorAll('.swiper-slide a, .swiper-slide button').forEach(link => {
          link.addEventListener('click', function (e) {
            if (swiper._moved) {
              e.preventDefault();
              e.stopPropagation();
              swiper._moved = false;
            }
          });
        });
      },
      destroy(swiper) {
        widget.classList.remove('is-swiper-initialized', 'with-slidesPerView-auto');
        if (dropdownWrapper && swiper._handlers) {
          dropdownWrapper.removeEventListener('shown.bs.dropdown', swiper._handlers.handleDropdownShown);
          dropdownWrapper.removeEventListener('hide.bs.dropdown', swiper._handlers.handleDropdownHide);
          swiper._handlers = null;
        }
      },
      touchStart(swiper, e) {
        const t = e.touches ? e.touches[0] : e;
        swiper._startX = t.clientX;
        swiper._startY = t.clientY;
        swiper._moved = false;
      },
      touchMove(swiper, e) {
        const MOVE_THRESHOLD = 10;
        const t = e.touches ? e.touches[0] : e;
        if (
          Math.abs(t.clientX - swiper._startX) > MOVE_THRESHOLD ||
          Math.abs(t.clientY - swiper._startY) > MOVE_THRESHOLD
        ) {
          swiper._moved = true;
        }
      },
    },
  };

  widget.style.setProperty('--bs-slide-gap', `${swiperOptions.spaceBetween}px`);

  const swiper = new Swiper(swiperEl, swiperOptions);

  swiperEl.closest('.modal')?.addEventListener('shown.bs.modal', () => {
    swiper.update();
  });

  return {
    swipers: [swiper],
    destroy: () => {
      if (!swiper.destroyed) swiper.destroy(true, true);
    },
  };
};
